import { render, staticRenderFns } from "./NotificationsTable.vue?vue&type=template&id=08f66c4f&"
import script from "./NotificationsTable.vue?vue&type=script&lang=js&"
export * from "./NotificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports